import PageHero from '@/components/feature/PageHero';

export default function SupplyHero() {
  return (
    <PageHero
      eyebrow="九畴云铺 · 供给数字化"
      title="从「产品」到「数字商品」，从「卖商品」到「卖服务」"
      titleHighlight="供应链 · 服务业务"
      desc="供应链让农产品实现数字化上行，服务业务让县域形成「商品经济 + 服务经济」的双轮驱动。"
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20agricultural%20supply%20chain%20digitalization%20visualization%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20flow%20connecting%20farm%20origin%20to%20digital%20shelf%20to%20consumer%2C%20rural%20digital%20economy%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=jiuchou-supply-01&orientation=landscape"
      imageAlt="九畴云铺 供应链与服务业务"
      imageTitle="九畴云铺 供应链与服务业务"
    />
  );
}